import React, {ReactNode, useEffect, useState} from "react";

interface CheckboxConformiteProps {
  isChecked: boolean;
  onUpdatedConformite: (isChecked: boolean) => void;
  traduction: (arg0: string) => ReactNode;
}

export const CheckboxConformite = (props: CheckboxConformiteProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(props.isChecked);

  useEffect(() => {
    if(props.isChecked !== isChecked) {
      setIsChecked(isChecked);
    }
  }, [props.isChecked])

  function onUpdatedConformite(value: boolean) {
    setIsChecked(value);
    props.onUpdatedConformite(value);
  }

  return (
      <div className={"d-flex flex-column"}>
        <div className={'w-75 text-center align-self-center p-1'}>
          <p className={'mb-0 italic'}>{props.traduction('info_check_conformite')}</p>
        </div>
        <div id={'divConformite'} className={'d-flex align-items-baseline justify-content-center p-3 pl-0 pb-0 cursor-pointer alert alert-warning'} onClick={() => {onUpdatedConformite(!isChecked)}}>
          <div className="pl-0 mr-2">
            <input id="conformite" type="checkbox" name="checkConformite" autoComplete="off" className="" checked={isChecked} value={`${isChecked}`} onChange={() => {onUpdatedConformite(!isChecked)}}/>
          </div>
          <label htmlFor="checkConformite" className={`m-0 cursor-pointer`}>
            {props.traduction('label_check_conformite')}
          </label>
        </div>
      </div>
  );
}